
import { FETCH_ONBOARDING_REQUEST_LIST } from "../../actions/actionTypes";

const initialState = {
    data: [],
    isLoading: false,
    next:null,
    statusCount:{}
};

const reducer = (state=initialState, action)=>{
   // console.log("action", action)
    switch(action.type){
        case FETCH_ONBOARDING_REQUEST_LIST.REQUEST:
            return {...state, isLoading: true}
        case FETCH_ONBOARDING_REQUEST_LIST.FAILURE:
            return {...state, isLoading:false}
        case FETCH_ONBOARDING_REQUEST_LIST.SUCCESS:     
        return {
            ...state,
            // data: action.obj.isLoadMore ? [...state.data,...action.obj.data] : action.obj.data,
            data:  action.obj.data,
            next: action.obj.next,
            isLoading:false,
            statusCount: action.obj.statusCount
          };      
        default:
            return state
    }   
}

export default reducer;